import styled from 'styled-components';
import { limitLines } from 'src/styles';

export const AuthorName = styled.span`
  font-size: 1.125rem;
  ${limitLines(2)}
`;

AuthorName.displayName = 'AuthorName';

export const ThumbnailWrapper = styled.div`
  height: 4rem;
  width: 4rem;
`;

ThumbnailWrapper.displayName = 'ThumbnailWrapper';

type PostTitleProps = {
  hasThumbnail: boolean;
};

export const PostTitle = styled.h3<PostTitleProps>`
  --thumbnail-width: 4rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: ${({ hasThumbnail }) => (hasThumbnail ? 'calc(100% - var(--thumbnail-width))' : '100%')};
`;

PostTitle.displayName = 'PostTitle';
